import { FEATURE_GROUPS } from './features-data'
import { FEATURE_VISUALS } from './FeatureVisuals'
import { card, Em, pad, SectionHead } from './primitives'

export function Features() {
  return (
    <section id="features" className="landing-shell scroll-mt-20 pt-28">
      <SectionHead
        eyebrow="Features"
        title={
          <>
            What ships <Em>today</Em>
          </>
        }
        note="Every entry maps to running code in the desktop app. The specs are the real surface, not marketing labels."
      />

      <div className={card}>
        {FEATURE_GROUPS.map((f, i) => {
          const Visual = FEATURE_VISUALS[f.id]
          return (
            <article
              key={f.id}
              className="grid gap-6 border-t border-dashed border-rule p-6 first:border-t-0 lg:grid-cols-12 lg:gap-8"
            >
              <span className="num text-[12px] text-ink-3 lg:col-span-1">{pad(i + 1)}</span>
              <div className="lg:col-span-4">
                <span className="mono-label text-ink-3">{f.tag}</span>
                <h3 className="mt-3 text-[24px] leading-[1.15] tracking-[-0.02em]">{f.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink-2">{f.lead}</p>
                {f.note ? <p className="mt-3 text-[13px] leading-relaxed text-ink-3">{f.note}</p> : null}
              </div>
              <ul className="self-start lg:col-span-3">
                {f.specs.map((spec) => (
                  <li
                    key={spec}
                    className="border-t border-dashed border-rule py-2 font-mono text-[12px] text-ink-2 first:border-t-0 first:pt-0"
                  >
                    {spec}
                  </li>
                ))}
              </ul>
              <div className="lg:col-span-4">
                <div className="h-[196px]">
                  {Visual ? <Visual /> : null}
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}
